import { Button } from '@mantine/core';

import React from 'react';

const PDFdownloadButton = ({
  pdfUrl,
  pdfName = 'download.pdf',
  className = '',
  children = 'Download PDF',
  onClick = () => {},
}) => {
  return (
    <Button
      className={`bg-purple text-white ${className}`}
      onClick={() => {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        onClick();
      }}
    >
      {children}
    </Button>
  );
};

export default PDFdownloadButton;
